import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';
import { toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchSampleProductList } from '@store/actions/SampleAction';

import { onUpdateEOD } from '@services/quoteServices';

import { getShortName, getTodaysDate, renderSetImages, setTag } from '@utils/Util';

const EodAddModal = ({ selectedDesignIds, onCloseModal, onSuccessEodUpdate }) => {
	const [selectedDesigns, setSelectedDesigns] = useState([]);
	const [eoDate, setEoDate] = useState(null);
	const [error, setError] = useState(false);
	const sampleStore = useSelector((store) => store.sampleStore);
	const dispatch = useDispatch();
	const { id } = useParams();

	useEffect(() => {
		setSelectedDesigns(sampleStore.selectedProducts);
	}, [sampleStore]);

	useEffect(() => {
		dispatch(openLoader());
		dispatch(fetchSampleProductList(selectedDesignIds)).finally(() => {
			dispatch(closeLoader());
		});
	}, []);

	const validateDate = () => {
		let cloneError = {};
		if (!eoDate) {
			cloneError.eod = 'EOD is required';
		}
		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};

	const onSubmit = async () => {
		if (!validateDate()) {
			try {
				dispatch(openLoader());
				const response = await onUpdateEOD(id, selectedDesignIds, eoDate);
				onSuccessEodUpdate();
				dispatch(closeLoader());
				toastSuccess(response?.message);
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	return (
		<ModalContainer className="expected-order-date-modal" onCloseModal={() => {}}>
			<div className="common-popup expected-order-date-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte d-flex align-items-center">
						<h3 className="semibold-16 mb-0">Expected Order Date (EOD)</h3>
					</div>
					<div className="close-btn" onClick={onCloseModal}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="selected-style-container">
						<div className="eo-date">
							<div className="form-group">
								<label htmlFor="date">Date</label>
								<input
									type="date"
									name="eoDate"
									min={getTodaysDate()}
									value={eoDate}
									onChange={(e) => setEoDate(e.target.value)}
								/>
								{error.eod && <p className="error">{error.eod}</p>}
							</div>
						</div>
						<div className="selected-styles">
							<h3 className="semibold-14 gray_dark_02">Selected Styles</h3>
							<div className="d-grid grid-columns-3 gap-3">
								{selectedDesigns?.map((item, idx) => (
									<div
										className="single-item d-flex align-items-center"
										key={`selected_design_${idx}`}
									>
										<div className="images-half">
											{item.isSet ? (
												renderSetImages(item?.designDocuments, ' 80px')
											) : (
												<img
													src={item?.designDocuments[0]?.docUrl}
													alt="image"
													className="single-product-image"
												/>
											)}
										</div>

										<div className="ml-12">
											{item.isSet && setTag()}
											<p className="regular-12 weight-500 gray_dark_01 py-1">
												<Tooltip title={item?.referenceNumber} placement="top" arrow>
													<span className="regular-12 gray_dark_02">
														{getShortName(item?.referenceNumber, 10)}
													</span>
												</Tooltip>
											</p>
											<ul className="common-list-component mb-2">
												<li>{item?.productGroup}</li>
												<li>{item?.category}</li>
											</ul>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer pt-0">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32 ml-2" onClick={onCloseModal}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default EodAddModal;
